import gql from 'graphql-tag';

export default gql`
  fragment maintenanceProspectPoolCounts on MaintenanceProspectPoolCounts {
    targetFromCount
  }
`;
